import { ReactNode, createContext, useContext, useMemo } from 'react'

import { useLocale } from 'context/LocaleContext'

export const GA_TRACKING_ID = {
  ar: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_AR!,
  cl: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_CL!,
  co: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_CO!,
  ec: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_EC!,
  pe: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_PE!,
  uy: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_UY!,
  br: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_BR!,
  mx: process.env.NEXT_PUBLIC_GA4_TRACKING_ID_MX!
} as const

type GtmContextValue = {
  dataLayerPush: (params: { [key: string]: any }) => void
}

const GtmContext = createContext<GtmContextValue | null>(null)

type GtmProviderProps = {
  children: ReactNode
}

export const GtmProvider = ({ children }: GtmProviderProps) => {
  const { locale } = useLocale()

  const value = useMemo<GtmContextValue>(() => {
    const initialParams = {
      location: locale
    }

    return {
      dataLayerPush: (params: { [key: string]: any }) => {
        if (typeof window === 'undefined') return
        if (!Array.isArray(window.dataLayer)) {
          window.dataLayer = []
        }

        window.dataLayer.push({
          ...params,
          ...initialParams
        })
      }
    }
  }, [locale])

  return <GtmContext.Provider value={value}>{children}</GtmContext.Provider>
}

export const useGtmTrack = () => {
  const context = useContext(GtmContext)

  if (!context) {
    throw new Error('useGtmTrack deve ser usado dentro de GtmProvider')
  }

  return context
}
